<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;height:100%;overflow:hidden;">
        <section class="container-footer" >
          <div class="popup-del" @click="cancelBack" ref="navBarH">
            <span class="icon icon-chacha f18"></span>
          </div>
          <!-- <div class="home-per">
            <van-collapse v-model="activeNames" class="perfect">
              <van-collapse-item name="0">
                <div slot="title"><span class="f12">行业类型</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':positionClassSysNoList.indexOf(item.CategorySysNo)>-1}"
                     v-for="(item,index) in cateList" :key="index"
                     @click="onCheck(item.CategorySysNo,'positionClassSysNoList')">
                    <span class="block txt-elips">{{item.CategoryName}}</span>
                  </p>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div> -->
      <section class="select-job-top van-hairline--top" ref="jobTop">
      <search-bar v-model="keyWord" placeholder="搜索" background="#fff" action-color="c-333" @search="onSearch" @clear="onClear" :action="!searchList.length"  ref="searchBarH"></search-bar>
      <div class="ds-job-selected plr15 pt8 clearfix" v-if="!searchList.length">
        <p v-for="(position, index) in selectPositionList" :key="position.id" @click.prevent.stop="delSelectPosition(index)">
          {{position.name}} <b class="txt-c"><span class="icon icon-chacha f10 c-white"></span></b>
        </p>
      </div>
      <p class="p-normal f12 c-gray" v-if="!searchList.length">最多可选10个</p>
      </section>

      <section class="select-job-top-content flex all-t" v-if="!searchList.length">
      <div class="ds-job-select-cat" :style="{height:'calc(100vh - '+ jobTopH +')'}">
        <p :class="{'active': index === selectIndustryIndex}" v-for="(industry, index) in industryList" :key="index" @click.stop="selectIndustry(index)">{{industry.name}}</p>
      </div>

      <div class="ds-job-select-item flex-1" :style="{height:'calc(100vh - '+ jobTopH +')'}" :id="'industry-list-' + enterType">
        <position-item v-for="(industry, index) in industryList" :industry="industry" :select-position-id-list="selectPositionIdList" :key="index" :id="'industry-item-' + enterType + '-' + index" @select-position="selectPosition"></position-item>
      </div>
      </section>

    <!-- 搜索结果样式如下 -->

      <!-- <section class="search-result van-hairline--top" :style="{height:'calc(100vh - '+ searchTopH +')', top: searchTopH}" v-if="searchList.length"> -->
      <section class="search-result van-hairline--top" style="height:80vh;" v-if="searchList.length">
      <div class="p-normal van-hairline--bottom" v-for="(item, index) in searchList" :key="index" @click.prevent.stop="selectPosition(item)">
        <p class="f16">
          <span class="c-primary" :class="{'c-orange': sItem === keyWord}" v-for="(sItem, sIndex) in item.KeyWords" :key="sIndex">{{sItem}}</span>
        </p>
        <p class="c-gray">{{item.fname }}</p>
      </div>
      </section>
        </section>
        <footer class="footer-fixed flex all-c" ref="footerH">
      <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
      </footer>
        <!-- <footer class="footer-fixed flex all-c">
          <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
        </footer> -->
    </van-popup>
  </div>
</template>

<script>
import PositionItem from 'components/position-item';
import SearchBar from 'components/search-bar';
import api from '../../../api';

  export default {
    components: {
      PositionItem,
      SearchBar
    },
    data() {
      return {
        show: false,
        showFilter: false,
        activeNames: ['0', '1', '2', '3', '4', '5', '6'],
        cateList: [],
        tagClassNameList: [],
        positionClassSysNoList: [],
        positionTagClassNameList: [], // old
        jobTopH: 0,
        searchTopH: 0,
        caculated: false,
        industryList: [],
        selectPositionList: [], // 缓存已选中的item
        selectPositionNameList: [],
        selectPositionIdList: [],
        selectIndustryIndex: 0,
        keyWord: '',
        searching: false,
        searchList: [],
        checkExits: false
      };
    },
    props: {
      enterType: {
        type: Number,
        default: 0
      }
    },
    mounted() {
      // 由父组件传入 industryList，不再自己请求
      // this.getCategorys();
    },
    watch: {
      show(val) {
        if (val) {
          this.$nextTick(() => {
            if (!this.caculated) {
              this.caculated = true;
            this.jobTopH =
          this.$refs.jobTop.offsetHeight +
          this.$refs.navBarH.offsetHeight +
          this.$refs.footerH.offsetHeight -
          2 +
          'px';
          this.searchTopH = this.$refs.searchBarH.offsetHeight ? this.$refs.searchBarH.offsetHeight : 0 + this.$refs.navBarH.offsetHeight + 'px';
          // this.$toast(this.jobTopH + '-' + this.searchTopH);
            }
          });
        }
      }
    },
    methods: {
      async getCategorys() {
        try {
          // 使用 api.get 调用新接口
          let result = await api.get('/api/vpai/recruit/list_positions');          
          // 新接口返回格式: { code: 10000, data: [{ hyName, positionTypes: [{ gwId, gwName }] }] }
          // 或直接返回数组（取决于axios拦截器处理）
          const dataList = Array.isArray(result) ? result : (result.data || []);
          
          dataList.forEach((item, index) => {
            let industry = {
              id: index + 1, // 使用索引+1作为行业ID
              name: item.hyName,
              positions: []
            };
            (item.positionTypes || []).forEach(childItem => {
              industry.positions.push({
                id: childItem.gwId,
                name: childItem.gwName
              });
            });
            this.industryList.push(industry);
          });
        } catch (e) {
          this.$toast(e.message);
        }
      },
      selectIndustry(index) {
      this.selectIndustryIndex = index;
      let item = document.getElementById(`industry-item-${this.enterType}-${index}`);
      let top = item.offsetTop - item.parentNode.offsetTop - 10;
      if (top) {
        document.getElementById(`industry-list-${this.enterType}`).scrollTop = top;
        const sTop = document.documentElement.scrollTop || document.body.scrollTop;
        window.scrollTo(sTop, sTop + 1);
      }
    },
    selectPosition(position) {
      if (
        this.selectPositionList.length < 10 &&
        this.selectPositionIdList.indexOf(position.id) === -1 &&
        this.selectPositionNameList.indexOf(position.name) === -1
      ) {
        this.selectPositionList.push(position);
        this.selectPositionIdList.push(position.id);
        this.selectPositionNameList.push(position.name);
      } else if (this.selectPositionList.length === 10) {
        this.$toast('亲，最多选10个！');
      }
      this.onClear();
    },
    delSelectPosition(index) {
      this.selectPositionList.splice(index, 1);
      this.selectPositionIdList.splice(index, 1);
      this.selectPositionNameList.splice(index, 1);
    },
    onClear() {
      this.keyWord = '';
      this.searchList.splice(0, this.searchList.length);
    },
    clear() {
      while (this.selectPositionList.length > 0) {
        this.selectPositionList.splice(0, 1);
        this.selectPositionIdList.splice(0, 1);
        this.selectPositionNameList.splice(0, 1);
      }
    },
    onSearch() {
      if (this.searching) {
          return;
        }
        this.searching = true;
        if (this.keyWord) {
          this.searchList.splice(0, this.searchList.length);
          const getKeyWords = (str, key) => str.replace(new RegExp(`${key}`, 'g'), `%%${key}%%`).split('%%');
          this.checkExits = false;
          this.industryList.forEach(c => {
            c.positions.forEach(d => {
              if (d.name.indexOf(this.keyWord) > -1) {
                this.checkExits = true;
                let ary = getKeyWords(d.name, this.keyWord);
                this.searchList.push({
                  fid: c.id,
                  fname: c.name,
                  ...d,
                  KeyWords: ary
                });
              }
            });
          });
          if (!this.checkExits) {
            this.$toast('没有找到相关内容！');
          }
        } else {
          this.searchList.splice(0, this.searchList.length);
        }
        this.searching = false;
    },
    cancelBack() {
      if (this.enterType === 2) {
        this.$emit('search', {});
        this.show = false;
      } else {
        this.show = false;
      }
    },
      search() {
        console.log(JSON.stringify(this.selectPositionIdList));
        console.log(JSON.stringify(this.selectPositionNameList));
        let positionClassShowNameTips = '';
        if (this.selectPositionNameList && this.selectPositionNameList.length > 0) {
          positionClassShowNameTips = this.selectPositionNameList.join(',');
          if (positionClassShowNameTips.length > 2) {
            positionClassShowNameTips = positionClassShowNameTips.substring(0, 2) + '..';
          }
        }
        this.$emit('search', {
          PositionClassSysNoList: this.selectPositionIdList,
          PositionClassShowList: this.selectPositionNameList,
          PositionClassItemList: this.selectPositionList,
          PositionClassShowNameTips: positionClassShowNameTips
          // PositionTagClassNameList: this.positionTagClassNameList
        });
        this.show = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }

  .ds-partime-list {
    padding-top: 1px;
  }

  .fringe .van-cell__value--alone {
    color: #666;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  body{overflow:hidden}
.select-job-top .van-search__content {
  background-color: darken(@bgLightGray, 1.2%);
}

.ds-job-select-cat {
  width: 97px;
  overflow: auto;
  background: darken(@bgLightGray, 1.2%);
  text-align: center;
  position: relative;
}

.ds-job-select-cat > p {
  line-height: 43px;
  padding: 0 5px;
}

.ds-job-select-cat > p.active {
  color: @primaryColor;
  background: @white;
  border-color: @white;
}

.ds-job-selected > p {
  line-height: 1;
  float: left;
  margin: 0 8px 8px 0;
  border: 1px solid @borderColor;
  border-radius: 3px;
  padding: 8px 17px;
  position: relative;
}

.ds-job-selected > p > b {
  position: absolute;
  top: -5px;
  right: -5px;
  background:@red;
  border-radius:100%;
  width: 15px;
  height: 15px;
  line-height:15px;
}

.ds-job-select-item {
  padding: 10px;
  box-sizing: border-box;
  // overflow: auto;
  overflow-y:scorll;
  -webkit-overflow-scrolling: touch;
}

.ds-job-select-item /deep/ div > p > span {
  font-size: 12px;
  line-height: 30px;
  float: left;
  margin: 0 10px 10px 0;
  padding: 0 10px;
  background: lighten(@gray, 34%);
}

.search-result{ position: fixed; left: 0; width: 100%; background: @white; z-index: 1000; overflow: auto;}

// 覆盖van-search__action样式
.van-search__action:active{background:@white;}
</style>
